// API Configuration
//const HOST = "http://vny-2025/";
const HOST = "https://register-service.vietnamyounglions.net/";

// Helper function to build full API URLs
const buildApiUrl = (endpoint: string): string => {
  return `${HOST}${endpoint}`;
};

// API Endpoints Constants
export const API_URL = {
  // Base URLs
  HOST,
  BASE_API: `${HOST}api/`,

  // Authentication endpoints
  AUTH: {
    LOGIN: buildApiUrl("api/auth/login-direct"),
    REGISTER: buildApiUrl("api/auth/register-direct"),
    FORGOT_PASSWORD: buildApiUrl("api/auth/forgot-password"),
    RESET_PASSWORD: buildApiUrl("api/auth/reset-password"),
    VERIFY_EMAIL: buildApiUrl("api/auth/verify-email"),
    VALIDATE_RESET_TOKEN: buildApiUrl("api/auth/validate-reset-token"),
    REFRESH: buildApiUrl("api/auth/refresh"),
    CHANGE_PASSWORD: buildApiUrl("api/auth/change-password"),
  },

  // User profile endpoints
  USER: {
    PROFILE: buildApiUrl("api/user/profile"),
    UPLOAD_ID_CARD: buildApiUrl("api/user/upload-id-card"),
    UPLOAD_STUDENT_ID: buildApiUrl("api/user/upload-student-id"),
    UPLOAD_CV: buildApiUrl("api/user/upload-cv"),
  },

  // Data endpoints
  DATA: {
    COMPANIES: buildApiUrl("api/companies"),
    SCHOOLS: buildApiUrl("api/schools"),
  },

  // Team endpoints
  TEAMS: {
    CREATE: buildApiUrl("api/teams/create"),
    JOIN: buildApiUrl("api/teams/join"),
    MY_TEAM: buildApiUrl("api/teams/my-team"),
    MY_TEAMS: buildApiUrl("api/teams/my-teams"), // All user teams
    LEAVE: buildApiUrl("api/teams/leave"),
    DETAILS: buildApiUrl("api/teams"), // Base URL for {teamId}/details
    CONFIRM_MEMBER: buildApiUrl("api/teams"), // Base URL for {teamId}/confirm-member
    REJECT_MEMBER: buildApiUrl("api/teams"), // Base URL for {teamId}/reject-member
    CANCEL_JOIN_REQUEST: buildApiUrl("api/teams"), // Base URL for {teamId}/cancel-join-request
    SIGN_TERMS: buildApiUrl("api/teams"), // Base URL for {teamId}/sign-terms
    SUBMIT_FOR_APPROVAL: buildApiUrl("api/teams"), // Base URL for {teamId}/submit-for-approval
  },

  // Storage URLs (for image previews)
  STORAGE: {
    ID_CARDS: `${HOST}storage/id-cards/`,
    STUDENT_IDS: `${HOST}storage/student-ids/`,
    PORTFOLIOS: `${HOST}storage/portfolios/`,
  },

  // Competition endpoints
  COMPETITIONS: {
    MY_COMPETITIONS: buildApiUrl("api/competitions/my-competitions"),
    TEAM_STATUS: buildApiUrl("api/competitions/team"), // + /{teamId}/status
    GET_BRIEF: buildApiUrl("api/competitions/brief"), // + /{teamId}
    UPLOAD: buildApiUrl("api/competitions/upload"),
    BIG_IDEA: buildApiUrl("api/competitions/big-idea"),
    SUBMIT: buildApiUrl("api/competitions/submit"),
    RESULTS: buildApiUrl("api/competitions/results"), // + /{teamId}
    SCHEDULE: buildApiUrl("api/competitions/schedule"),
  },
} as const;

// Export individual constants for convenience
export const {
  AUTH: API_AUTH,
  USER: API_USER,
  DATA: API_DATA,
  TEAMS: API_TEAMS,
  STORAGE: API_STORAGE,
  COMPETITIONS: API_COMPETITIONS,
} = API_URL;

// Export HOST for any custom URL building
export { HOST };
